import { render, staticRenderFns } from "./ArticleParagraph.vue?vue&type=template&id=0022267a&name=article-paragraph&"
import script from "./ArticleParagraph.vue?vue&type=script&lang=js&"
export * from "./ArticleParagraph.vue?vue&type=script&lang=js&"
import style0 from "./ArticleParagraph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports